module.exports = __webpack_public_path__ + "img/EMS.e61f58c6.png";